import { render, staticRenderFns } from "./ChangeLogViewer.vue?vue&type=template&id=b0bdd6f6"
import script from "./ChangeLogViewer.vue?vue&type=script&lang=ts"
export * from "./ChangeLogViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports